import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconRefresh = props => (
  <SvgIcon {...props} viewBox="0 0 16 15.999999">
    <path d="m13.6 2.4c-1.4-1.5-3.4-2.4-5.6-2.4-4.4-4.7684e-7 -8 3.6-8 8s3.6 8 8 8c3.7 0 6.8-2.6 7.7-6h-2.1c-0.8 2.3-3 4-5.6 4-3.3 0-6-2.7-6-6s2.7-6 6-6c1.7 0 3.1 0.7 4.2 1.8l-3.2 3.2h7v-7l-2.4 2.4z" />
  </SvgIcon>
);

export default IconRefresh;



// WEBPACK FOOTER //
// ./src/components/icons/IconRefresh.js